export default __webpack_public_path__ + "static/media/laburdick.fb3d7398.jpeg";